import React from 'react';
import { useDataTable } from '../DataTable';

type DataTableSelectionControlsProps = {
  colSpan: number;
};

const DataTableSelectionControls: React.FC<DataTableSelectionControlsProps> = ({ colSpan }) => {
  const { selectedRowIds, clearSelection, bulkActionComponents } = useDataTable();

  const count = selectedRowIds.length;

  return (
    <thead>
      <tr>
        <th className="p-0" colSpan={colSpan}>
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 bg-light-primary rounded px-4 py-3 border border-primary border-dashed">
            <div className="d-flex align-items-center gap-3">
              <span className="fw-bold text-primary">
                {count} {count === 1 ? 'item selecionado' : 'itens selecionados'}
              </span>
              <button
                className="btn btn-sm btn-link text-gray-600 text-hover-primary p-0"
                type="button"
                onClick={clearSelection}
              >
                Limpar seleção
              </button>
            </div>
            <div className="d-flex gap-3 flex-wrap">
              {bulkActionComponents?.map((component, index) => (
                <React.Fragment key={index}>{component}</React.Fragment>
              ))}
            </div>
          </div>
        </th>
      </tr>
    </thead>
  );
};

export default DataTableSelectionControls;
